var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 32,
    viewBox: "0 0 62 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8059_12678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5122 0V5.11564H46.9192L52.5122 8.22857V14.9333L43.5905 9.88299L34.6689 15.2816V8.59864L40.2166 5.11564H34.6462V0H52.5122Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1842 19.6354H43.2735V17.1755H36.4351V32H62V0H55.1616V19.6354H55.1842ZM55.1842 26.8844H43.2735V25.0993H55.1842V26.8844Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3892 0H16.9614V6.57415H23.5508V17.1755H30.3892V0Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5196 6.57415V0H5.11872H0.0917969V6.57415V10.9714V17.1755H5.11872H13.5196V10.9714H6.79437V6.57415H13.5196Z",
    fill: "#0073EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8059_12678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.5e8908ffcc78a523eaf16c36b7e00412.svg";
export { ForwardRef as ReactComponent };